"use strict";

require("core-js/modules/es6.object.define-property");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Selectors = {
  COMMON: {
    PAGE_CONTENT: '.js_content_page'
  },
  GALLERY: {
    MAIN: ".product-gallery",
    NAV: ".product-gallery-nav"
  },
  CART_ADD: '.js_product_page_add_to_cart',
  FAVORITE_ADD: '.js_favorites_add',
  VERSIONS: {
    DATA: '#version_data',
    SWITCHES: '.js_version_switch',
    FIELDS: {
      NAME: '#version_NAME',
      AMOUNT: '#version_AMOUNT',
      PRICE: '#version_PRICE',
      PRICE_OLD: '#version_PRICE_OLD',
      CODE: '#version_CODE',
      DELIVERY_TIME: '#version_DELIVERY_TIME',
      DESCRIPTION: '#version_DESC'
    }
  },
  SHARE: {
    TWITTER_SHARE: '.js_twitter_share',
    FACEBOOK_SHARE: '.js_facebook_share',
    LINKEDIN_SHARE: '.js_linkedin_share'
  },
  ASK_MODAL: {
    BTN: '.js_ask_form',
    POPUP: '#form-ask-popup',
    FORM: '#ask-product-form',
    SUBMIT_BUTTON: '#ask-product-form-submit',
    RESULT: '.sending-result',
    OTHER_COUNTRY_CHECKBOX: '#form-ask-popup input#ask_other_country',
    REGION_SELECT: '#form-ask-popup select#ask_region',
    RECAPTCHA: '#form-ask-popup #g-recaptcha-ask',
    RECAPTCHA_ERROR_MSG: '#form-ask-popup .g-recaptcha-ask-error'
  },
  AVAILABLE_MODAL: {
    BTN: '.js_ask_available',
    POPUP: '#form-available-popup',
    FORM: '#available-product-form',
    SUBMIT_BUTTON: '#available-product-form-submit',
    RESULT: '.sending-result',
    RECAPTCHA: '#form-available-popup #g-recaptcha-available',
    RECAPTCHA_ERROR_MSG: '#form-available-popup .g-recaptcha-available-error'
  },
  CAT_TITLE: {
    COMPONENT: '.category_title_component',
    TITLE: '.category_title',
    TEXT: '.category_desc',
    BTN: '.desc_more'
  },
  CAT_IMAGE: '.category_main_img',
  REVIEW: {
    DUMMY: '#js_review_dummy',
    INJECTOR: '#js_review_injector',
    CONTAINER: '#addRating',
    ADDED_REVIEW: '.product-page-review',
    SHOW_MORE_REVIEWS: '#js_show_reviews',
    PREPARE_REVIEW_LINK: '#js_add_review'
  }
};